import { TenantEntity } from '../TenantEntity'

export class Vgm extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'Vgm'
  }
  get shipperLine1() {
    return this._data.shipperLine1
  }
  set shipperLine1(shipperLine1) {
    this._data.shipperLine1 = shipperLine1
  }
  get shipperLine2() {
    return this._data.shipperLine2
  }
  set shipperLine2(shipperLine2) {
    this._data.shipperLine2 = shipperLine2
  }
  get shipperLine3() {
    return this._data.shipperLine3
  }
  set shipperLine3(shipperLine3) {
    this._data.shipperLine3 = shipperLine3
  }
  get shipperLine4() {
    return this._data.shipperLine4
  }
  set shipperLine4(shipperLine4) {
    this._data.shipperLine4 = shipperLine4
  }
  get shipperLine5() {
    return this._data.shipperLine5
  }
  set shipperLine5(shipperLine5) {
    this._data.shipperLine5 = shipperLine5
  }
  get shipperLine6() {
    return this._data.shipperLine6
  }
  set shipperLine6(shipperLine6) {
    this._data.shipperLine6 = shipperLine6
  }
  get shipperLine7() {
    return this._data.shipperLine7
  }
  set shipperLine7(shipperLine7) {
    this._data.shipperLine7 = shipperLine7
  }
  get shipperContact() {
    return this._data.shipperContact
  }
  set shipperContact(shipperContact) {
    this._data.shipperContact = shipperContact
  }
  get shipperContactEmail() {
    return this._data.shipperContactEmail
  }
  set shipperContactEmail(shipperContactEmail) {
    this._data.shipperContactEmail = shipperContactEmail
  }
  get shipperContactWay() {
    return this._data.shipperContactWay
  }
  set shipperContactWay(shipperContactWay) {
    this._data.shipperContactWay = shipperContactWay
  }
  get shipperPerson() {
    return this._data.shipperPerson
  }
  set shipperPerson(shipperPerson) {
    this._data.shipperPerson = shipperPerson
  }
  get companyContact() {
    return this._data.companyContact
  }
  set companyContact(companyContact) {
    this._data.companyContact = companyContact
  }
  get companyContactEmail() {
    return this._data.companyContactEmail
  }
  set companyContactEmail(companyContactEmail) {
    this._data.companyContactEmail = companyContactEmail
  }
  get companyContactWay() {
    return this._data.companyContactWay
  }
  set companyContactWay(companyContactWay) {
    this._data.companyContactWay = companyContactWay
  }
  get companyPrincipal() {
    return this._data.companyPrincipal
  }
  set companyPrincipal(companyPrincipal) {
    this._data.companyPrincipal = companyPrincipal
  }
  get companyName() {
    return this._data.companyName
  }
  set companyName(companyName) {
    this._data.companyName = companyName
  }
  get companyAddress() {
    return this._data.companyAddress
  }
  set companyAddress(companyAddress) {
    this._data.companyAddress = companyAddress
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get cargoDocUuid() {
    return this._data.cargoDocUuid
  }
  set cargoDocUuid(cargoDocUuid) {
    this._data.cargoDocUuid = cargoDocUuid
  }
}
